import * as React from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ClientSummaryGroupModel } from "../../../../../../Wrap/Models/Models/Business/ClientSummary/ClientSummaryGroupModel";

interface IAssetAllocationChart {
    data: ClientSummaryGroupModel[];
}

export const ClientSummaryChart = (props: IAssetAllocationChart) => {
    const _data = props.data.concat();
    if (!_data || _data.length == 0) {return null;}
    let countSum = 0;
    _data.forEach((x) => (countSum += x.Count));
    const Data = _data.map((ele) => {
        return {
            name: ele.GroupStartValue.toString(),
            y: Number((ele.Count > 0 ? (ele.Count / countSum) * 100 : 0).toFixed(2)),
        };
    });

    const options: Highcharts.Options = {
        chart: {
            renderTo: "container",
            type: "pie",
            width: 300,
            height: 300,
            backgroundColor: "rgba(255,255,255,0)",
        },
        colors: ["#0057B7", "#72246c", "#008264", "#E24082", "#000000", "#A7A8A9"],
        title: {
            text: "",
        },
        navigator: {
            enabled: false,
        },
        rangeSelector: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: "client count",
            },
        },
        plotOptions: {
            pie: {
                shadow: false,
            },
        },
        tooltip: {
            formatter: function () {
                return "<b>" + this.point.name + "</b>: " + this.y + " %";
            },
        },
        series: [
            {
                name: "Client summary",
                type: "pie",
                data: Data,
                size: "80%",
                innerSize: "93%",
                selected: false,
                showInLegend: false,
                dataLabels: {
                    enabled: false,
                },
            },
        ],
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    );
};
